<template>
  <div>
    <div style="font-size: 22px" class="pl-4 mt-4">
      สำนักงานส่งเสริมเศรษฐกิจดิจิทัล (สำนักงานใหญ่)
    </div>
    <v-divider></v-divider>
    <div class="pa-5">
      <v-row dense>
        <v-col cols="2">
          <v-icon size="30px">mdi-map-marker-outline</v-icon>
        </v-col>
        <v-col cols="10">
          <div class="pl-0">
            80 ถนนลาดพร้าว ซอยลาดพร้าว 4 แขวงจอมพล เขต จตุจักร กรุงเทพมหานคร
            10900
          </div>
          <div class="mt-4">
            <div>Tel : (+66) 0-2026-2333</div>
            <div>Fax : (+66) 0-2026-2333</div>
          </div>
          <div class="mt-4">
            <div>Email : Doss@depa.or.th</div>
          </div>
        </v-col>
      </v-row>
      <div
        class="mt-6"
        style="position: relative; width: 100%; height: 0; padding-top: 100%"
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7748.904352317822!2d100.561682!3d13.811865!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe1c64aa0a0229427!2z4Liq4Liz4LiZ4Lix4LiB4LiH4Liy4LiZ4Liq4LmI4LiH4LmA4Liq4Lij4Li04Lih4LmA4Lio4Lij4Lip4LiQ4LiB4Li04LiI4LiU4Li04LiI4Li04LiX4Lix4LilIChkZXBhKQ!5e0!3m2!1sth!2sth!4v1617783986141!5m2!1sth!2sth"
          style="
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
          "
          frameborder="0"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>